/**
 * Created by zsp on 2018/6/04.
 */

import axios from 'axios'
import store from '../store'
import { getToken } from '@/utils/cookie'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000, // 请求超时时间
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

service.interceptors.request.use(config => {
  if (getToken()) {
    config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

service.interceptors.response.use(response => {
  const res = response.data
  if (response.status === 401) {
    store.dispatch('LogOut').then(() => location.reload())
  } else if (res.code === 401 || res.code === 10000) {
    alert(res.msg)
    return Promise.reject(res)
  } else if (res.code === 403 || res.code === 402) {
    store.dispatch('LogOut').then(() => location.reload())
  } else if (res.code !== 200) {
    alert(res.msg || res.err)
    return Promise.reject(res)
  } else {
    return response.data
  }
}, error => {
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js